import React from 'react';
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import Alert from "v4/components/admin/Alert/Alert";
import useCreateCoreLink from "v4/hooks/useCreateCoreLink";
import './CoreMovedAlert.scss';

/**
 *
 * @param {string} corePath - The pol-core path this administration has been moved to.
 * @returns {JSX.Element} The alert with a link to the pol-core administration.
 */

export default function CoreMovedAlert({corePath}) {
    const {t} = usePolTranslation();

    const coreLink = useCreateCoreLink(corePath);

    return (
        <Alert
            type="warning"
            title={t('warning')}
            message={t('core_moved_config')}
        >
            <a href={coreLink}
               target="_blank"
               rel="noopener noreferrer"
               className="core-moved-alert__link"
            >
                {coreLink}
            </a>
        </Alert>
    )
}
